import { API } from '../Auth';

const EP = 'discoverRuns';
const BASE = '/api/v1/profile/jobs';
const CANCEL_PATH = (jobId) => `${BASE}/${encodeURIComponent(jobId)}/cancel`;

/**
 * Start a profile (schema metadata) run against an existing data source.
 * Returns the created orchestration job DTO (id, state, dataSourceId, …).
 */
export async function startProfileJob(dataSourceId) {
  return API.post(EP, BASE, { body: { dataSourceId } });
}

/**
 * List profile jobs for the current user, optionally filtered by data source.
 * Backend returns a Spring Data Page envelope with rows under `content`.
 * Status filtering is client-side — the backend list endpoint doesn't take it.
 */
export async function listProfileJobs({ dataSourceId, page = 0, size = 20 } = {}) {
  const queryStringParameters = {};
  if (dataSourceId != null) queryStringParameters.dataSourceId = String(dataSourceId);
  if (page != null) queryStringParameters.page = page;
  if (size != null) queryStringParameters.size = size;
  return API.get(EP, BASE, { queryStringParameters });
}

/**
 * Request cancellation of an in-flight profile job. Cooperative — the worker
 * checks a flag on its next loop step.
 */
export async function cancelProfileJob(jobId) {
  return API.post(EP, CANCEL_PATH(jobId), {});
}

/**
 * Single profile job. Unlike the list, this LIVE-SYNCS an active job with the worker
 * (fresh workItems counters) — the running-row progress bars poll it.
 */
export async function getProfileJob(jobId) {
  return API.get(EP, `${BASE}/${encodeURIComponent(jobId)}`);
}
